/**
 * Journal date filters — port of the journal/page.tsx client-side filtering:
 * Alle / Dieser Monat / Letzter Monat / Dieses Quartal / Frühere Beiträge.
 * Cards carry data-date (YYYY-MM-DD); the date math mirrors the source
 * (this month, previous calendar month, current quarter, everything before
 * the current quarter). Empty state toggles when no card matches.
 */
(function () {
  'use strict';

  function parseDate(str) {
    var parts = (str || '').split('-');
    return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
  }

  function isThisMonth(d, now) {
    return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
  }

  function isLastMonth(d, now) {
    var y = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
    var m = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
    return d.getFullYear() === y && d.getMonth() === m;
  }

  function isThisQuarter(d, now) {
    var quarterStart = Math.floor(now.getMonth() / 3) * 3;
    return d.getFullYear() === now.getFullYear() && d.getMonth() >= quarterStart;
  }

  function matches(filterId, d, now) {
    if (filterId === 'alle') return true;
    if (filterId === 'dieser-monat') return isThisMonth(d, now);
    if (filterId === 'letzter-monat') return isLastMonth(d, now);
    if (filterId === 'dieses-quartal') return isThisQuarter(d, now);
    return !isThisQuarter(d, now); // frueher
  }

  function init() {
    var grid = document.querySelector('[data-journal-grid]');
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-journal-filter]'));
    if (!grid || buttons.length === 0) return;
    if (grid.dataset.journalInit) return;
    grid.dataset.journalInit = '1';

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-journal-card]'));
    var empty = grid.querySelector('[data-journal-empty]');

    function apply(filterId) {
      var now = new Date();
      var shown = 0;
      cards.forEach(function (card) {
        var show = matches(filterId, parseDate(card.getAttribute('data-date')), now);
        card.hidden = !show;
        if (show) shown += 1;
      });
      if (empty) empty.hidden = shown > 0;
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-journal-filter') === filterId);
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        apply(btn.getAttribute('data-journal-filter'));
      });
    });
  }

  init();

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
